import { createSlice } from '@reduxjs/toolkit';
import Swal from 'sweetalert2';
import { useSelector, useDispatch } from 'react-redux';


const initialState = {
  countPanier: 0,
  contentPanier: []
};
let nextId = 4
export const panierSlice = createSlice({
  name: 'panier',
  initialState,

  reducers: {
    incrementNbrePanier: (state, action) => {
      console.log('in')
      state.countPanier += action.payload
    },
    // ajout d'élément dans le panier
    addToCart(state, action) {
      const item = action.payload;

      // Vérifier si l'élément est déjà présent dans le panier pour la même personne
      const existingItem = state.contentPanier.find(
        (product) => product.id === item.id && product.userId === item.userId
      );

      if (existingItem) {
        // Afficher une notification pour informer l'utilisateur que l'élément existe déjà dans son panier
        Swal.fire({
          icon: "warning",
          title: "Cette publication existe déjà dans votre panier",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          background: "red",
          color: "white",
          iconColor: "white",
        });
        return; // Ne pas ajouter l'élément au panier car il existe déjà
      }

      // Ajouter l'élément au panier
      state.contentPanier.push(item);
      state.countPanier += 1;

      // Afficher une notification de succès pour informer l'utilisateur que l'élément a été ajouté au panier
      Swal.fire({
        icon: "success",
        title: "Vous avez ajouté une nouvelle publication dans votre panier",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: "green",
        color: "white",
        iconColor: "white",
      });
    },
    // augmentation de quantité
    incrementQ(state, action){
        const item = action.payload;
        state.countPanier += 1
        let productItem = state.contentPanier.find(product => product.id === item.id);
        if(productItem){
          productItem.quantity += 1;
          Swal.fire({
            icon: "success",
                    title: 'Vous avez augmenté la quantité pour cette publication',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "yellow",
                    color: "black",
                    iconColor: "black"
          });
        }
    },
    decrementQ(state, action){
        const item = action.payload;
        state.countPanier -= 1
        let productItem = state.contentPanier.find(product => product.id === item.id);
        if(productItem){
          productItem.quantity -= 1;
          if(productItem.quantity === 0){
            state.contentPanier = state.contentPanier.filter(product => product.id !== item.id);
          }
          Swal.fire({
            icon: "success",
                    title: 'Vous avez dimunié la quantité pour cette publication',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "grey",
                    color: "white",
                    iconColor: "white"
          });
        }
    },
    removeFromCart(state, action){
        const item = action.payload;
        state.contentPanier = state.contentPanier.filter(product => product.id !== item.id);
        state.countPanier -= item.quantity;

        // Réinitialiser countPanier à zéro si toutes les publications ont été supprimées
      if (state.contentPanier.length === 0) {
        state.countPanier = 0;
      }

        Swal.fire({
          icon: "success",
                    title: 'Vous avez supprimé cette publication de votre panier',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    background: "red",
                    color: "white",
                    iconColor: "white"
        });
    },
    resetCart: (state) => {
      state.contentPanier = []; // réinitialise les articles du panier à un tableau vide
      state.countPanier = 0; // réinitialise le compte du panier à zéro
    },
  },
 
});




export const { resetCart } = panierSlice.actions;

export const { incrementNbrePanier, addToCart, incrementQ, decrementQ, removeFromCart } = panierSlice.actions;

export const countPanier = (state) => state.panierProvider.countPanier;

export default panierSlice.reducer;